<template>
  <div class="p-42 my-52 insights-container">
    <div class="relative">
      <div
        @click.prevent="showVideo"
        class="absolute-header"
        style="top: -17px; right: 0"
      >
        <div class="button-header flex-mid">
          <i class="el-icon-caret-right"></i>
        </div>
      </div>
    </div>
    <div v-if="warningModal" class="relative center flex-mid">
      <div class="warning-modal">
        <div class="center fc-FFFFFF fs-16">
          {{ $t("weMonthlyInsights.engaged.youIndicatedThat") }}
          <span class="fw-700">{{ warning.name }}</span>
          {{ $t("weMonthlyInsights.engaged.isNoLonger") }}
        </div>
        <div class="flex-mid mt-24">
          <div @click="warning(false)" class="cancel mr-12">
            {{ $t("weMonthlyInsights.engaged.cancel") }}
          </div>
          <div @click="warning(true)" class="notify">
            {{ $t("weMonthlyInsights.engaged.notifyAdmins") }}
          </div>
        </div>
      </div>
    </div>
    <div class="fs-18 fw-900">
      {{ $t("weMonthlyInsights.engaged.howEngagedAre") }}
    </div>
    <div class="flex">
      <div class="opa-07 fc-15253C">
        {{ $t("weMonthlyInsights.engaged.progressBasedOn") }}
      </div>
      <!-- <div class="ml-auto flex fs-12" style="width: 200px">
        <div
          @click.prevent="activeGrowingTab = 'directReports'"
          :class="`tab-header flex-mid left ${
            activeGrowingTab === 'directReports' ? 'active-tab' : ''
          }`"
          style="width: 120px"
        >
          Direct Reports Only
        </div>
        <div
          @click.prevent="activeGrowingTab = 'overallTeam'"
          :class="`tab-header flex-mid right ${
            activeGrowingTab === 'overallTeam' ? 'active-tab' : ''
          }`"
          style="width: 80px"
        >
          Overall Team
        </div>
      </div> -->
    </div>
    <div class="pt-10 chart-header relative">
      <div class="line"></div>
      <div class="previous flex-center">
        <div class="color"></div>
        <span> {{ $t("weMonthlyInsights.engaged.previousMonth") }} </span>
      </div>
      <div
        :class="`${
          activeGrowingTab === 'directReports' ? '' : 'opa-00'
        } pt-10 chart-absolute`"
      >
        <canvas ref="directReportsChart" height="220" width="700"></canvas>
      </div>

      <!-- <div
        :class="`${
          activeGrowingTab === 'directReports' ? 'opa-00' : ''
        } pt-10 chart-absolute`"
      >
        <canvas ref="overallTeamChart" height="220"></canvas>
      </div> -->
    </div>
    <div v-if="activeGrowingTab === 'directReports'">
      <div class="flex-center type-tabs">
        <!-- <div
          @click.prevent="
            clickFocusNewEngaged(
              'directReports',
              'superEngaged',
              directReports.engagedValue.superEngaged
            )
          "
          :class="`font-lato card ${focusClassAtEngagedTabs(
            'directReports',
            'superEngaged'
          )} flex-center ${
            directReports.engagedValue.superEngaged ? 'cursor-pointer' : ''
          }`"
        >
          <div class="number flex-mid superEngaged">
            <div v-if="user.boss" class="ml-auto">
              {{ directReports.engagedValue.superEngaged }}
            </div>
          </div>
          <div class="text">
            <div>{{ $t("weMonthlyInsights.engaged._super") }}</div>
            <div>{{ $t("weMonthlyInsights.engaged._engaged") }}</div>
          </div>
        </div> -->
        <div
          @click.prevent="
            clickFocusNewEngaged(
              'directReports',
              'highlyEngaged',
              directReports.engagedValue.highlyEngaged
            )
          "
          :class="`font-lato card ${focusClassAtEngagedTabs(
            'directReports',
            'highlyEngaged'
          )} flex-center ${
            directReports.engagedValue.highlyEngaged ? 'cursor-pointer' : ''
          }`"
        >
          <div class="number flex-mid highlyEngaged">
            <div v-if="user.boss" class="ml-auto">
              {{ directReports.engagedValue.highlyEngaged }}
            </div>
          </div>
          <div class="text">
            <div>{{ $t("weMonthlyInsights.engaged._highly") }}</div>
            <div>{{ $t("weMonthlyInsights.engaged._engaged") }}</div>
          </div>
        </div>
        <div
          @click.prevent="
            clickFocusNewEngaged(
              'directReports',
              'moderatelyEngaged',
              directReports.engagedValue.moderatelyEngaged
            )
          "
          :class="`font-lato card ${focusClassAtEngagedTabs(
            'directReports',
            'moderatelyEngaged'
          )} flex-center ${
            directReports.engagedValue.moderatelyEngaged ? 'cursor-pointer' : ''
          }`"
        >
          <div class="number flex-mid moderatelyEngaged">
            <div v-if="user.boss" class="ml-auto">
              {{ directReports.engagedValue.moderatelyEngaged }}
            </div>
          </div>
          <div class="text">
            <!-- <div>{{ $t("weMonthlyInsights.engaged._moderately") }}</div> -->
            <div>{{ $t("weMonthlyInsights.engaged._engaged") }}</div>
          </div>
        </div>
        <div
          @click.prevent="
            clickFocusNewEngaged(
              'directReports',
              'somewhatEngaged',
              directReports.engagedValue.somewhatEngaged
            )
          "
          :class="`font-lato card ${focusClassAtEngagedTabs(
            'directReports',
            'somewhatEngaged'
          )} flex-center ${
            directReports.engagedValue.somewhatEngaged ? 'cursor-pointer' : ''
          }`"
        >
          <div class="number flex-mid somewhatEngaged">
            <div v-if="user.boss" class="ml-auto">
              {{ directReports.engagedValue.somewhatEngaged }}
            </div>
          </div>
          <div class="text">
            <div>{{ $t("weMonthlyInsights.engaged._somewhat") }}</div>
            <div>{{ $t("weMonthlyInsights.engaged._engaged") }}</div>
          </div>
        </div>
        <div
          @click.prevent="
            clickFocusNewEngaged(
              'directReports',
              'underEngaged',
              directReports.engagedValue.notEngaged
            )
          "
          :class="`font-lato card ${focusClassAtEngagedTabs(
            'directReports',
            'underEngaged'
          )} flex-center ${
            directReports.engagedValue.notEngaged ? 'cursor-pointer' : ''
          }`"
        >
          <div class="number flex-mid notEngaged">
            <div v-if="user.boss" class="ml-auto">
              {{ directReports.engagedValue.notEngaged }}
            </div>
          </div>
          <div class="text">
            <div>{{ $t("weMonthlyInsights.engaged._not") }}</div>
            <div>{{ $t("weMonthlyInsights.engaged._engaged") }}</div>
          </div>
        </div>
        <div
          @click.prevent="
            clickFocusNewEngaged(
              'directReports',
              'inActive',
              directReports.engagedValue.inActive
            )
          "
          :class="`font-lato card ${focusClassAtEngagedTabs(
            'directReports',
            'inActive'
          )} flex-center ${
            directReports.engagedValue.inActive ? 'cursor-pointer' : ''
          }`"
        >
          <div class="number flex-mid inActive">
            <div v-if="user.boss" class="ml-auto">
              {{ directReports.engagedValue.inActive }}
            </div>
          </div>
          <div class="text">
            <div>{{ $t("weMonthlyInsights.engaged.inActive") }}</div>
          </div>
        </div>
      </div>
      <div
        class="px-16 pt-20 pb-40"
        v-if="user.boss && directReports.engagedFocusData.length != 0"
      >
        <div class="fs-15 mb-24">
          {{ $t("weMonthlyInsights.engaged.youHave") }}
          <span
            class="fw-700"
            v-if="directReports.engagedFocusType == 'superEngaged'"
            >{{ directReports.engagedValue.superEngaged }}
            {{ $t("weMonthlyInsights.engaged.superEngaged") }}</span
          >
          <span
            class="fw-700"
            v-else-if="directReports.engagedFocusType == 'highlyEngaged'"
            >{{ directReports.engagedValue.highlyEngaged }}
            {{ $t("weMonthlyInsights.engaged.highlyEngaged") }}</span
          >
          <span
            class="fw-700"
            v-else-if="directReports.engagedFocusType == 'moderatelyEngaged'"
            >{{ directReports.engagedValue.moderatelyEngaged }}
            {{ $t("weMonthlyInsights.engaged.moderatelyEngaged") }}
          </span>
          <span
            class="fw-700"
            v-else-if="directReports.engagedFocusType == 'somewhatEngaged'"
            >{{ directReports.engagedValue.somewhatEngaged }}
            {{ $t("weMonthlyInsights.engaged.somewhatEngaged") }}
          </span>
          <span
            class="fw-700"
            v-else-if="directReports.engagedFocusType == 'notEngaged'"
            >{{ directReports.engagedValue.notEngaged }}
            {{ $t("weMonthlyInsights.engaged.notEngaged") }}</span
          >
          <span
            class="fw-700"
            v-else-if="directReports.engagedFocusType == 'underEngaged'"
            >{{ directReports.engagedValue.notEngaged }}
            {{ $t("weMonthlyInsights.engaged.underEngaged") }}</span
          >
          <span
            class="fw-700"
            v-else-if="directReports.engagedFocusType == 'inActive'"
            >{{ directReports.engagedValue.inActive }}
            {{ $t("weMonthlyInsights.engaged.inActive") }}</span
          >

          {{ $t("weMonthlyInsights.engaged.membersOnYour") }}
        </div>
        <div class="px-9 carousel flex-mid">
          <div
            v-if="directReports.engagedFocus != 0"
            @click.prevent="anotherCard('directReports', 'left')"
            class="arrow left flex-mid"
          >
            <img
              style="width: 26px; height: 26px"
              src="../../assets/icons/black_chevron_left@2x.png"
              alt=""
            />
          </div>
          <div v-else class="arrow left hide"></div>
          <div class="engaged-contrainer flex-mid">
            <div
              v-for="(user, index) in directReports.engagedFocusData"
              :key="index + '_two_card_' + user.name"
            >
              <div
                v-if="index == directReports.engagedFocus"
                :class="`engaged-card mr-8 ${user.inActive ? 'in-active' : ''}`"
              >
                <div class="flex-center">
                  <div v-if="user.image">
                    <img
                      v-lazy="user.image"
                      :key="user.image"
                      class="image-skeleton image-profile-36 flex-mid mr-10"
                    />
                  </div>
                  <div v-else class="image image-profile-36 flex-mid mr-10">
                    <div
                      class="flex-mid text-in-image text-in-image-36"
                      style="width: 36px"
                    >
                      {{
                        $utils("acronymName", {
                          firstName: user.firstname,
                          lastName: user.lastname,
                        })
                      }}
                    </div>
                  </div>
                  <div class="fs-000000">
                    <div class="fs-13 fw-500">{{ user.name }}</div>
                    <div class="opa-06 fs-12">{{ user.teamName }}</div>
                  </div>
                </div>
                <div v-if="!user.inActive" class="mr-30 ml-8">
                  <div
                    class="flex-center"
                    v-for="value in user.engagementKey"
                    :key="'tex-' + value"
                  >
                    <div class="mt-18 mr-12">
                      <img
                        v-if="checkIcon(value)"
                        :src="
                          require(`@/assets/images/wv-monthly-insights/engeged/check.png`)
                        "
                        style="width: 20px; height: 20px"
                      />
                      <img
                        v-else
                        :src="
                          require(`@/assets/images/wv-monthly-insights/engeged/cross.png`)
                        "
                        style="width: 20px; height: 20px"
                      />
                    </div>
                    <div class="mt-18 fs-13 fc-000000">
                      {{ value }}
                    </div>
                  </div>
                </div>
                <div v-else class="fs-13 mt-18">
                  <div class="fc-000000">
                    This member was inactive this month.
                  </div>
                  <div class="fc-000000 mt-20">
                    Encourage them to participate in feedback and recognition to
                    foster positive growth.
                  </div>
                  <div
                    @click="setWaring(user)"
                    class="cursor-pointer fc-0CACA5"
                    style="margin-top: 50px"
                  >
                    Is this member no longer on the team?
                  </div>
                </div>
              </div>
            </div>
            <div
              v-for="(user, index) in directReports.engagedFocusData"
              :key="index + '_one_card_' + user.id"
            >
              <div
                v-if="
                  index == directReports.engagedFocus + 1 && user.id !== 'blank'
                "
                :class="`engaged-card ml-8 ${user.inActive ? 'in-active' : ''}`"
              >
                <div class="flex-center">
                  <div v-if="user.image">
                    <img
                      v-lazy="user.image"
                      :key="user.image"
                      class="image-skeleton image-profile-36 flex-mid mr-10"
                    />
                  </div>
                  <div v-else class="image image-profile-36 flex-mid mr-10">
                    <div
                      class="flex-mid text-in-image text-in-image-36"
                      style="width: 36px"
                    >
                      {{
                        $utils("acronymName", {
                          firstName: user.firstname,
                          lastName: user.lastname,
                        })
                      }}
                    </div>
                  </div>
                  <div class="fs-000000">
                    <div class="fs-13 fw-500">{{ user.name }}</div>
                    <div class="opa-06 fs-12">{{ user.teamName }}</div>
                  </div>
                </div>
                <div v-if="!user.inActive" class="mr-30 ml-8">
                  <div
                    class="flex-center"
                    v-for="value in user.engagementKey"
                    :key="'tex-' + value"
                  >
                    <div class="mt-18 mr-12">
                      <img
                        v-if="checkIcon(value)"
                        :src="
                          require(`@/assets/images/wv-monthly-insights/engeged/check.png`)
                        "
                        style="width: 20px; height: 20px"
                      />
                      <img
                        v-else
                        :src="
                          require(`@/assets/images/wv-monthly-insights/engeged/cross.png`)
                        "
                        style="width: 20px; height: 20px"
                      />
                    </div>
                    <div class="mt-18 fs-13 fc-000000">
                      {{ value }}
                    </div>
                  </div>
                </div>
                <div v-else class="fs-13 mt-18">
                  <div class="fc-000000">
                    This member was inactive this month.
                  </div>
                  <div class="fc-000000 mt-20">
                    Encourage them to participate in feedback and recognition to
                    foster positive growth.
                  </div>
                  <div
                    @click="setWaring(user)"
                    class="cursor-pointer fc-0CACA5"
                    style="margin-top: 50px"
                  >
                    Is this member no longer on the team?
                  </div>
                </div>
              </div>
              <div
                v-if="
                  index == directReports.engagedFocus + 1 && user.id == 'blank'
                "
                style="width: 282px"
              ></div>
            </div>
          </div>
          <div
            v-if="
              !(directReports.engagedFocusData.length % 2 == 0) &&
              !(
                directReports.engagedFocus <
                directReports.engagedFocusData.length - 2
              )
            "
            style="width: 282px"
          ></div>
          <div
            v-if="
              directReports.engagedFocus <
              directReports.engagedFocusData.length - 2
            "
            @click.prevent="anotherCard('directReports', 'right')"
            class="arrow right flex-mid"
          >
            <img
              style="width: 26px; height: 26px; margin-left: 4px"
              src="../../assets/icons/black_chevron_right@2x.png"
              alt=""
            />
          </div>
          <div v-else class="arrow left hide"></div>
        </div>
      </div>
      <div v-else class="pt-20"></div>
    </div>
    <div v-else>
      <div class="flex-center type-tabs">
        <div
          @click.prevent="
            clickFocusNewEngaged(
              'overallTeam',
              'superEngaged',
              overallTeam.engagedValue.superEngaged
            )
          "
          :class="`font-lato card ${focusClassAtEngagedTabs(
            'overallTeam',
            'superEngaged'
          )} flex-center ${
            overallTeam.engagedValue.superEngaged ? 'cursor-pointer' : ''
          }`"
        >
          <div class="number flex-mid superEngaged">
            <div v-if="user.boss" class="ml-auto">
              {{ overallTeam.engagedValue.superEngaged }}
            </div>
          </div>
          <div class="text">
            <div>{{ $t("weMonthlyInsights.engaged._super") }}</div>
            <div>{{ $t("weMonthlyInsights.engaged._engaged") }}</div>
          </div>
        </div>
        <div
          @click.prevent="
            clickFocusNewEngaged(
              'overallTeam',
              'highlyEngaged',
              overallTeam.engagedValue.highlyEngaged
            )
          "
          :class="`font-lato card ${focusClassAtEngagedTabs(
            'overallTeam',
            'highlyEngaged'
          )} flex-center ${
            overallTeam.engagedValue.highlyEngaged ? 'cursor-pointer' : ''
          }`"
        >
          <div class="number flex-mid highlyEngaged">
            <div v-if="user.boss" class="ml-auto">
              {{ overallTeam.engagedValue.highlyEngaged }}
            </div>
          </div>
          <div class="text">
            <div>{{ $t("weMonthlyInsights.engaged._highly") }}</div>
            <div>{{ $t("weMonthlyInsights.engaged._engaged") }}</div>
          </div>
        </div>
        <div
          @click.prevent="
            clickFocusNewEngaged(
              'overallTeam',
              'moderatelyEngaged',
              overallTeam.engagedValue.moderatelyEngaged
            )
          "
          :class="`font-lato card ${focusClassAtEngagedTabs(
            'overallTeam',
            'moderatelyEngaged'
          )} flex-center ${
            overallTeam.engagedValue.moderatelyEngaged ? 'cursor-pointer' : ''
          }`"
        >
          <div class="number flex-mid moderatelyEngaged">
            <div v-if="user.boss" class="ml-auto">
              {{ overallTeam.engagedValue.moderatelyEngaged }}
            </div>
          </div>
          <div class="text">
            <!-- <div>{{ $t("weMonthlyInsights.engaged._moderately") }}</div> -->
            <div>{{ $t("weMonthlyInsights.engaged._engaged") }}</div>
          </div>
        </div>
        <div
          @click.prevent="
            clickFocusNewEngaged(
              'overallTeam',
              'somewhatEngaged',
              overallTeam.engagedValue.somewhatEngaged
            )
          "
          :class="`font-lato card ${focusClassAtEngagedTabs(
            'overallTeam',
            'somewhatEngaged'
          )} flex-center ${
            overallTeam.engagedValue.somewhatEngaged ? 'cursor-pointer' : ''
          }`"
        >
          <div class="number flex-mid somewhatEngaged">
            <div v-if="user.boss" class="ml-auto">
              {{ overallTeam.engagedValue.somewhatEngaged }}
            </div>
          </div>
          <div class="text">
            <div>{{ $t("weMonthlyInsights.engaged._somewhat") }}</div>
            <div>{{ $t("weMonthlyInsights.engaged._engaged") }}</div>
          </div>
        </div>
        <div
          @click.prevent="
            clickFocusNewEngaged(
              'overallTeam',
              'underEngaged',
              overallTeam.engagedValue.notEngaged
            )
          "
          :class="`font-lato card ${focusClassAtEngagedTabs(
            'overallTeam',
            'underEngaged'
          )} flex-center ${
            overallTeam.engagedValue.notEngaged ? 'cursor-pointer' : ''
          }`"
        >
          <div class="number flex-mid notEngaged">
            <div v-if="user.boss" class="ml-auto">
              {{ overallTeam.engagedValue.notEngaged }}
            </div>
          </div>
          <div class="text">
            <div>{{ $t("weMonthlyInsights.engaged._not") }}</div>
            <div>{{ $t("weMonthlyInsights.engaged._engaged") }}</div>
          </div>
        </div>
      </div>
      <div class="px-16 pt-20 pb-40">
        <div class="fs-15 mb-24">
          {{ $t("weMonthlyInsights.engaged.youHave") }}
          <span class="fw-700"
            >{{ overallTeam.engagedValue.superEngaged }}
            {{ $t("weMonthlyInsights.engaged.superEngaged") }}</span
          >
          {{ $t("weMonthlyInsights.engaged.membersOnYour") }}
        </div>
        <div class="px-9 carousel flex-mid">
          <div
            v-if="focusOTbuttonLeft"
            @click.prevent="anotherCard('overallTeam', 'left')"
            class="arrow left flex-mid"
          >
            <img
              style="width: 26px; height: 26px"
              src="../../assets/icons/black_chevron_left@2x.png"
              alt=""
            />
          </div>
          <div v-else class="arrow left hide"></div>
          <div class="engaged-contrainer flex-mid">
            <div
              v-for="(user, index) in overallTeam.engagedFocusData"
              :key="index + '_two_card_' + user.name"
            >
              <div
                v-if="index == overallTeam.engagedFocus"
                :class="`engaged-card mr-8 ${user.inActive ? 'in-active' : ''}`"
              >
                <div class="flex-center">
                  <div v-if="user.image">
                    <img
                      v-lazy="user.image"
                      :key="user.image"
                      class="image-skeleton image-profile-36 flex-mid mr-10"
                    />
                  </div>
                  <div v-else class="image image-profile-36 flex-mid mr-10">
                    <div
                      class="flex-mid text-in-image text-in-image-36"
                      style="width: 36px"
                    >
                      {{
                        $utils("acronymName", {
                          firstName: user.firstname,
                          lastName: user.lastname,
                        })
                      }}
                    </div>
                  </div>
                  <div class="fs-000000">
                    <div class="fs-13 fw-500">{{ user.name }}</div>
                    <div class="opa-06 fs-12">{{ user.teamName }}</div>
                  </div>
                </div>
                <div v-if="!user.inActive" class="mr-30 ml-8">
                  <div
                    class="flex-center"
                    v-for="value in engagement.engagementKey"
                    :key="'tex-' + value"
                  >
                    <div class="mt-18 mr-12">
                      <img
                        v-if="checkIcon(value)"
                        :src="
                          require(`@/assets/images/wv-monthly-insights/engeged/check.png`)
                        "
                        style="width: 20px; height: 20px"
                      />
                      <img
                        v-else
                        :src="
                          require(`@/assets/images/wv-monthly-insights/engeged/cross.png`)
                        "
                        style="width: 20px; height: 20px"
                      />
                    </div>
                    <div class="mt-18 fs-13 fc-000000">
                      {{ value }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-for="(user, index) in overallTeam.engagedFocusData"
              :key="index + '_one_card_' + user.name"
            >
              <div
                v-if="index == overallTeam.engagedFocus + 1"
                :class="`engaged-card ml-8 ${user.inActive ? 'in-active' : ''}`"
              >
                <div class="flex-center">
                  <div v-if="user.image">
                    <img
                      v-lazy="user.image"
                      :key="user.image"
                      class="image-skeleton image-profile-36 flex-mid mr-10"
                    />
                  </div>
                  <div v-else class="image image-profile-36 flex-mid mr-10">
                    <div
                      class="flex-mid text-in-image text-in-image-36"
                      style="width: 36px"
                    >
                      {{
                        $utils("acronymName", {
                          firstName: user.firstname,
                          lastName: user.lastname,
                        })
                      }}
                    </div>
                  </div>
                  <div class="fs-000000">
                    <div class="fs-13 fw-500">{{ user.name }}</div>
                    <div class="opa-06 fs-12">{{ user.teamName }}</div>
                  </div>
                </div>
                <div v-if="!user.inActive" class="mr-30 ml-8">
                  <div
                    class="flex-center"
                    v-for="value in engagement.engagementKey"
                    :key="'tex-' + value"
                  >
                    <div class="mt-18 mr-12">
                      <img
                        v-if="checkIcon(value)"
                        :src="
                          require(`@/assets/images/wv-monthly-insights/engeged/check.png`)
                        "
                        style="width: 20px; height: 20px"
                      />
                      <img
                        v-else
                        :src="
                          require(`@/assets/images/wv-monthly-insights/engeged/cross.png`)
                        "
                        style="width: 20px; height: 20px"
                      />
                    </div>
                    <div class="mt-18 fs-13 fc-000000">
                      {{ value }}
                    </div>
                  </div>
                </div>
                <div v-else class="fs-13 mt-18">
                  <div class="fc-000000">
                    This member was inactive this month.
                  </div>
                  <div class="fc-000000 mt-20">
                    Encourage them to participate in feedback and recognition to
                    foster positive growth.
                  </div>
                  <div
                    @click="setWaring(user)"
                    class="cursor-pointer fc-0CACA5"
                    style="margin-top: 50px"
                  >
                    Is this member no longer on the team?
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              !(overallTeam.engagedData.length % 2 == 0) &&
              !(overallTeam.engagedFocus < overallTeam.engagedData.length - 2)
            "
            style="width: 282px"
          ></div>
          <div
            v-if="focusOTbuttonRight"
            @click.prevent="anotherCard('overallTeam', 'right')"
            class="arrow right flex-mid"
          >
            <img
              style="width: 26px; height: 26px; margin-left: 4px"
              src="../../assets/icons/black_chevron_right@2x.png"
              alt=""
            />
          </div>
          <div v-else class="arrow left hide"></div>
        </div>
      </div>
    </div>
    <div
      class="highly-engaged-card"
      :style="`background-color: ${matchBackgroundColor(engagement.engagementType)};`"
    >
      <div class="fs-15">
        {{ $t("weMonthlyInsights.engaged.youAre") }}
        <span class="fw-700">
          {{
            $t(`weMonthlyInsights.engaged.${engagement.engagementType}`)
          }}.</span
        >{{ $t("weMonthlyInsights.engaged.hereIsAn") }}
      </div>
      <div
        v-if="loading"
        class="mt-16 profile-card font-lato"
        style="height: 180px"
      >
        <div>
          <div class="flex-center">
            <div class="image image-profile-36 flex-mid mr-10"></div>
            <div class="fs-000000">
              <div class="fs-13 text-skeleton" style="width: 120px">&nbsp;</div>
              <div class="fs-12 text-skeleton mt-4" style="width: 90px">
                &nbsp;
              </div>
            </div>
          </div>
          <div class="mr-30 ml-8">
            <div
              class="flex-center"
              v-for="value in [1, 2]"
              :key="'tex-m-' + value"
            >
              <div class="mt-18 mr-12">
                <div
                  class="image-skeleton"
                  style="width: 20px; height: 20px; border-radius: 20px"
                ></div>
              </div>
              <div class="mt-18">
                <div class="text-skeleton fs-13" style="width: 210px">
                  &nbsp;
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right-card pt-14">
          <div class="challenges flex-center">
            <div class="status image-skeleton"></div>
            <div class="text-skeleton" style="width: 90px">&nbsp;</div>
          </div>
          <div class="challenges flex-center">
            <div class="status image-skeleton"></div>
            <div class="text-skeleton" style="width: 90px">&nbsp;</div>
          </div>
          <div class="challenges flex-center">
            <div class="status image-skeleton"></div>
            <div class="text-skeleton" style="width: 90px">&nbsp;</div>
          </div>
          <div class="challenges flex-center">
            <div class="status image-skeleton"></div>
            <div class="text-skeleton" style="width: 90px">&nbsp;</div>
          </div>
          <div class="challenges flex-center">
            <div class="status image-skeleton"></div>
            <div class="text-skeleton" style="width: 90px">&nbsp;</div>
          </div>
        </div>
      </div>
      <div v-else class="mt-16 profile-card font-lato">
        <div>
          <div class="flex-center">
            <div v-if="user.image">
              <img
                v-lazy="user.image"
                :key="user.image"
                class="image-skeleton image-profile-36 flex-mid mr-10"
              />
            </div>
            <div v-else class="image image-profile-36 flex-mid mr-10">
              <div
                class="flex-mid text-in-image text-in-image-36"
                style="width: 36px"
              >
                {{
                  $utils("acronymName", {
                    firstName: user.firstname,
                    lastName: user.lastname,
                  })
                }}
              </div>
            </div>
            <div class="fs-000000">
              <div class="fs-13 fw-500">{{ user.name }}</div>
              <div class="opa-06 fs-12">{{ user.teamName }}</div>
            </div>
          </div>
          <div class="mr-30 ml-8">
            <div
              class="flex-center"
              v-for="value in engagement.engagementKey"
              :key="'tex-' + value"
            >
              <div class="mt-18 mr-12">
                <img
                  v-if="checkIcon(value)"
                  :src="
                    require(`@/assets/images/wv-monthly-insights/engeged/check.png`)
                  "
                  style="width: 20px; height: 20px"
                />
                <img
                  v-else
                  :src="
                    require(`@/assets/images/wv-monthly-insights/engeged/cross.png`)
                  "
                  style="width: 20px; height: 20px"
                />
              </div>
              <div class="mt-18 fs-13 fc-000000">
                {{ value }}
              </div>
            </div>
          </div>
        </div>
        <div class="right-card pt-14">
          <div class="challenges flex-center">
            <img
              :src="
                require(`@/assets/images/wv-monthly-insights/monthly/${
                  engagement.challenges.dailyCheck || 'red'
                }/ic_daily_checkins.png`)
              "
              class="status"
            />
            <div>{{ $t("weMonthlyInsights.engaged.dailyCheckIns") }}</div>
          </div>
          <div class="challenges flex-center">
            <img
              :src="
                require(`@/assets/images/wv-monthly-insights/monthly/${
                  engagement.challenges.peerFeedback || 'red'
                }/ic_peer_feedback.png`)
              "
              class="status"
            />
            <div>{{ $t("weMonthlyInsights.engaged.peerFeedback") }}</div>
          </div>
          <div class="challenges flex-center">
            <img
              :src="
                require(`@/assets/images/wv-monthly-insights/monthly/${
                  engagement.challenges.feedback || 'red'
                }/ic_peer_feedback.png`)
              "
              class="status"
            />
            <div>{{ $t("weMonthlyInsights.engaged._feedback") }}</div>
          </div>
          <div class="challenges flex-center">
            <img
              :src="
                require(`@/assets/images/wv-monthly-insights/monthly/${
                  engagement.challenges.happilyVillage || 'red'
                }/ic_feedback.png`)
              "
              class="status"
            />
            <div>{{ $t("weMonthlyInsights.engaged.happilyVillage") }}</div>
          </div>
          <div class="challenges flex-center">
            <img
              :src="
                require(`@/assets/images/wv-monthly-insights/monthly/${
                  engagement.challenges.superFeedback || 'red'
                }/ic_super_feedback.png`)
              "
              class="status"
            />
            <div>{{ $t("weMonthlyInsights.engaged.superFeedback") }}</div>
          </div>
          <div class="challenges flex-center">
            <img
              :src="
                require(`@/assets/images/wv-monthly-insights/monthly/${
                  engagement.challenges.rewards || 'red'
                }/ic_rewards.png`)
              "
              class="status"
            />
            <div>{{ $t("weMonthlyInsights.engaged.rewards") }}</div>
          </div>
          <div class="challenges flex-center">
            <img
              :src="
                require(`@/assets/images/wv-monthly-insights/monthly/${
                  engagement.challenges.recognition || 'red'
                }/ic_recognition.png`)
              "
              class="status"
            />
            <div>{{ $t("weMonthlyInsights.engaged.recognition") }}</div>
          </div>
          <div class="challenges flex-center">
            <img
              :src="
                require(`@/assets/images/wv-monthly-insights/monthly/${
                  engagement.challenges.favoritedSparks || 'red'
                }/ic_favorited_sparks.png`)
              "
              class="status"
            />
            <div>{{ $t("weMonthlyInsights.engaged.favoritedSparks") }}</div>
          </div>
          <div class="challenges flex-center">
            <img
              :src="
                require(`@/assets/images/wv-monthly-insights/monthly/${
                  engagement.challenges.superRecognition || 'red'
                }/ic_super_recognition.png`)
              "
              class="status"
            />
            <div>{{ $t("weMonthlyInsights.engaged.superRecognition") }}</div>
          </div>
          <div class="challenges flex-center">
            <img
              :src="
                require(`@/assets/images/wv-monthly-insights/monthly/${
                  engagement.challenges.NetworkBuilding || 'red'
                }/ic_network_building.png`)
              "
              class="status"
            />
            <div>{{ $t("weMonthlyInsights.engaged.networkBuilding") }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";

export default {
  components: {
    loadingEven: require("../even/loading").default,
  },
  props: {
    user: {
      id: String,
      name: String,
      firstname: String,
      lastname: String,
      month: String,
      year: String,
      teamName: String,
      image: String,
    },
  },
  computed: {
    engagement() {
      return this.$store.getters["monthlyEngaged/engagement"];
    },
    current_dailyCheck() {
      return this.$store.getters["monthlyEngaged/current_dailyCheck"];
    },
    _directReports() {
      return this.$store.getters["monthlyEngaged/directReports"];
    },
    loading() {
      return this.$store.getters["monthlyEngaged/loading"];
    },
    directReportsData() {
      return this.$store.getters["monthlyEngaged/directReportsData"];
    },
    directReportsLoading() {
      return this.$store.getters["monthlyEngaged/directReportsLoading"];
    },
  },
  data() {
    return {
      activeGrowingTab: "directReports",
      engagedShowing: "superEngaged",
      config: {
        engagedType: [
          "highlyEngaged",
          "moderatelyEngaged",
          "somewhatEngaged",
          "underEngaged",
          "inActive",
        ],
      },
      // focusDRbuttonLeft: false,
      // focusDRbuttonRight: true,
      focusOTbuttonLeft: false,
      focusOTbuttonRight: true,
      // engagement: {
      //   engagementKey: [],
      //   challenges: {
      //     dailyCheck: "",
      //     peerFeedback: "",
      //     feedback: "",
      //     happilyVillage: "",
      //     superFeedback: "",
      //     rewards: "",
      //     recognition: "",
      //     favoritedSparks: "",
      //     superRecognition: "",
      //     battleMode: "",
      //   },
      // },
      directReports: {
        engagedValue: {
          superEngaged: 0,
          oldSuperEngaged: 0,
          highlyEngaged: 0,
          oldHighlyEngaged: 0,
          moderatelyEngaged: 0,
          oldModeratelyEngaged: 0,
          somewhatEngaged: 0,
          oldSomewhatEngaged: 0,
          notEngaged: 0,
          oldNotEngaged: 0,
        },
        engagedFocus: 0,
        engagedFocusType: "superEngaged",
        engagedFocusData: [],
        engagedData: [],
      },
      overallTeam: {
        engagedValue: {
          superEngaged: 2,
          oldSuperEngaged: 1,
          highlyEngaged: 1,
          oldHighlyEngaged: 2,
          moderatelyEngaged: 3,
          oldModeratelyEngaged: 4,
          somewhatEngaged: 0,
          oldSomewhatEngaged: 1,
          notEngaged: 2,
          oldNotEngaged: 3,
        },
        engagedFocus: 0,
        engagedFocusType: "superEngaged",
        engagedFocusTypeList: [],
        engagedFocusData: [],
        engagedData: [],
      },
      membersEngaged: [],
      myOverallTeamChart: null,
      myDirectReportsChart: null,
      chartOptions: {
        responsive: true,
        plugins: {
          tooltip: false,
          title: {
            display: false,
          },
          legend: {
            display: false,
          },
        },
        interaction: {
          intersect: false,
        },
        elements: {
          point: {
            backgroundColor: "red",
          },
        },
        scales: {
          x: {
            display: true,
            grid: {
              display: false,
            },
            title: {
              display: false,
            },
          },
          y: {
            display: false,
          },
        },
      },
      warningModal: false,
      warningData: {
        name: "Merl Komberg",
        id: "this_my_id",
      },
    };
  },

  mounted() {
    //this.$store.dispatch("monthlyEngaged/getTeam",this.user);
    //this.$store.dispatch("monthlyEngaged/getEngagedTeam",this.user);
    this.randerDirectReportEngaged();
  },
  methods: {
    async randerDirectReportEngaged() {
      if (!this.directReportsLoading) {
        const data = this.directReportsData.engagedData;
        const dataLength = data.length;
        const focusData = [];
        const typeList = [];
        if (dataLength > 0) {
          let fucusType = data[0].engagedType;
          for (let i = 0; i < dataLength; i++) {
            const lastValue = !(i < dataLength - 1);
            if (data[i].engagedType == fucusType) {
              typeList.push(data[i].engagedType);
              focusData.push(data[i]);
            } else {
              let checked2 = 0;
              typeList.push(data[i].engagedType);
              for (let i2 = 0; i2 < dataLength; i2++) {
                if (data[i2].engagedType == fucusType) {
                  checked2 += 1;
                }
              }
              if (checked2 % 2 == 0) {
                focusData.push(data[i]);
              } else {
                focusData.push({
                  engagedType: false,
                  id: "blank",
                });
                focusData.push(data[i]);
              }
              fucusType = data[i].engagedType;
            }

            if (lastValue) {
              let checked2 = 0;
              for (let i2 = 0; i2 < dataLength; i2++) {
                if (data[i2].engagedType == typeList[typeList.length - 1]) {
                  checked2 += 1;
                }
              }
              if (!(checked2 % 2 == 0)) {
                focusData.push({
                  engagedType: false,
                  id: "blank",
                });
              }
            }
          }
          this.directReports.engagedData = data;
          this.directReports.engagedValue = this._directReports.engagedValue;
          this.directReports.engagedFocusType = data[0].engagedType;
          this.directReports.engagedFocusTypeList = [...new Set(typeList)];
          this.directReports.engagedFocusData = [...new Set(focusData)];
        } else {
          this.directReports = {
            engagedValue: {
              superEngaged: 0,
              oldSuperEngaged: 0,
              highlyEngaged: 0,
              oldHighlyEngaged: 0,
              moderatelyEngaged: 0,
              oldModeratelyEngaged: 0,
              somewhatEngaged: 0,
              oldSomewhatEngaged: 0,
              notEngaged: 0,
              oldNotEngaged: 0,
            },
            engagedFocus: 0,
            engagedFocusType: "superEngaged",
            engagedFocusData: [],
            engagedData: [],
          };
        }
        await this.$utils("waitingTime", 200);
        this.randerDirectReportsChart();
      } else {
        await this.$utils("waitingTime", 100);
        this.randerDirectReportEngaged();
      }
    },
    changedEngagedFocus(focusType, func, fullData) {
      let newFocusData = [];
      for (let i = 0; i < fullData.length; i++) {
        newFocusData.push(fullData[i].engagedType);
      }
      let engagedType = [...new Set(newFocusData)];
      let nowEngagedType = focusType;
      for (let i = 0; i < engagedType.length; i++) {
        if (engagedType[i] == focusType && func == "back") {
          nowEngagedType = engagedType[i - 1];
          break;
        } else if (engagedType[i] == focusType && func == "next") {
          if (engagedType[i + 1]) {
            nowEngagedType = engagedType[i + 1];
            break;
          }
        }
      }
      if (nowEngagedType) {
        return {
          newType: nowEngagedType,
          data: this.randerNewEngagedFocusData(nowEngagedType, fullData),
        };
      } else {
        return {
          newType: focusType,
          data: this.randerNewEngagedFocusData(focusType, fullData),
        };
      }
    },
    randerNewEngagedFocusData(type, data) {
      let newFocusData = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].engagedType == type) {
          newFocusData.push(data[i]);
        }
      }
      return newFocusData;
    },
    clickFocusNewEngaged(tab, type, length) {
      if (tab === "directReports" && length > 0) {
        for (let i = 0; i < this.directReports.engagedFocusData.length; i++) {
          if (this.directReports.engagedFocusData[i].engagedType == type) {
            this.directReports.engagedFocus = i;
            break;
          }
        }
        this.directReports.engagedFocusType = type;
      } else if (tab === "overallTeam" && length > 0) {
        for (let i = 0; i < this.overallTeam.engagedFocusData.length; i++) {
          if (this.overallTeam.engagedFocusData == type) {
            this.overallTeam.engagedFocus = i;
            break;
          }
        }
        this.overallTeam.engagedFocusType = type;
      }
    },
    anotherCard(tab, arrow) {
      let newSelect = null;
      if (tab === "directReports") {
        this.directReports.engagedFocusType;
        let arrowValue = arrow === "left" ? -2 : 2;
        let changed = this.directReports.engagedFocus + arrowValue;
        if (changed > 0) {
          if (changed + 1 > this.directReports.engagedFocusData.length) {
            this.directReports.engagedFocusType =
              this.directReports.engagedFocusData[0].engagedType;
            this.directReports.engagedFocus = 0;
          } else {
            this.directReports.engagedFocusType =
              this.directReports.engagedFocusData[changed].engagedType;
            this.directReports.engagedFocus = changed;
          }
        } else {
          this.directReports.engagedFocusType =
            this.directReports.engagedFocusData[0].engagedType;
          this.directReports.engagedFocus = 0;
        }
      } else if (tab === "overallTeam") {
        let changed =
          this.overallTeam.engagedFocus + (arrow === "left" ? -2 : 2);
        if (changed > 0) {
          if (changed + 1 > this.overallTeam.engagedFocusData.length) {
            newSelect = this.changedEngagedFocus(
              this.overallTeam.engagedFocusType,
              "next",
              this.overallTeam.engagedData
            );
            this.overallTeam.engagedFocusType = newSelect.newType;
            this.overallTeam.engagedFocusData = newSelect.data;
            this.overallTeam.engagedFocus = 0;
          } else {
            this.overallTeam.engagedFocus = changed;
          }
        } else {
          newSelect = this.changedEngagedFocus(
            this.overallTeam.engagedFocusType,
            "back",
            this.overallTeam.engagedData
          );
          this.overallTeam.engagedFocusType = newSelect.newType;
          this.overallTeam.engagedFocusData = newSelect.data;
          this.overallTeam.engagedFocus = 0;
        }
      }
    },
    focusClassAtEngagedTabs(tab, type) {
      if (tab === "directReports" && this.user.boss) {
        const focus = this.directReports.engagedFocusType;
        if (type == focus) {
          return "focus";
        }
      } else if (tab === "overallTeam" && this.user.boss) {
        const focus = this.overallTeam.engagedFocusType;
        if (type == focus) {
          return "focus";
        }
      }
      return "";
    },
    chartCofigNewData(data) {
      if (data) {
        const superEngaged = data.superEngaged || 0;
        const highlyEngaged = data.highlyEngaged || 0;
        const moderatelyEngaged = data.moderatelyEngaged || 0;
        const somewhatEngaged = data.somewhatEngaged || 0;
        const notEngaged = data.notEngaged || 0;
        const inActive = data.inActive || 0;
        return [
          0,
          // superEngaged,
          // superEngaged > highlyEngaged ? highlyEngaged / 2 : superEngaged,
          highlyEngaged,
          highlyEngaged > moderatelyEngaged
            ? moderatelyEngaged / 2
            : highlyEngaged / 2,
          moderatelyEngaged,
          moderatelyEngaged > somewhatEngaged
            ? somewhatEngaged / 2
            : moderatelyEngaged / 2,
          somewhatEngaged,
          somewhatEngaged > notEngaged ? notEngaged / 2 : somewhatEngaged / 2,
          notEngaged,
          notEngaged > inActive ? inActive / 2 : notEngaged / 2,
          inActive,
          0,
        ];
      } else {
        return [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      }
    },
    chartCofigOldData(data) {
      if (data) {
        const oldSuperEngaged = data.oldSuperEngaged || 0;
        const oldHighlyEngaged = data.oldHighlyEngaged || 0;
        const oldModeratelyEngaged = data.oldModeratelyEngaged || 0;
        const oldSomewhatEngaged = data.oldSomewhatEngaged || 0;
        const oldNotEngaged = data.oldNotEngaged || 0;
        const oldInactive = data.oldInActive || 0;
        return [
          0,
          // oldSuperEngaged,
          // oldSuperEngaged > oldHighlyEngaged
          //   ? oldHighlyEngaged / 2
          //   : oldSuperEngaged / 2,
          oldHighlyEngaged,
          oldHighlyEngaged > oldModeratelyEngaged
            ? oldModeratelyEngaged / 2
            : oldHighlyEngaged / 2,
          oldModeratelyEngaged,
          oldModeratelyEngaged > oldSomewhatEngaged
            ? oldSomewhatEngaged / 2
            : oldModeratelyEngaged / 2,
          oldSomewhatEngaged,
          oldSomewhatEngaged > oldNotEngaged
            ? oldNotEngaged / 2
            : oldSomewhatEngaged / 2,
          oldNotEngaged,
          oldNotEngaged > oldInactive ? oldInactive / 2 : oldNotEngaged / 2,
          oldInactive,
          0,
        ];
      } else {
        return [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      }
    },
    randerDirectReportsChart() {
      var chart = this.$refs.directReportsChart;
      if (chart) {
        var ctx = chart.getContext("2d");
        var gradientFill = ctx.createLinearGradient(625, 0, 100, 0);
        gradientFill.addColorStop(1, "rgba(39, 188, 108, 0.6)");
        gradientFill.addColorStop(0.75, "rgba(98, 206, 148, 0.6)");
        gradientFill.addColorStop(0.5, "rgba(255, 186, 13, 0.6)");
        gradientFill.addColorStop(0.25, "rgba(242, 47, 60, 0.6)");
        gradientFill.addColorStop(0, "rgba(178, 178, 178, 0.4)");

        const _drEngagedValue = this.chartCofigNewData(
          this.directReports.engagedValue
        );
        const _drEngagedOldValue = this.chartCofigOldData(
          this.directReports.engagedValue
        );
        const allEngaged = [..._drEngagedValue, ..._drEngagedOldValue];
        let maxValue = 0;
        for (const x in allEngaged) {
          if (maxValue < allEngaged[x]) {
            maxValue = allEngaged[x];
          }
        }
        maxValue = this.$utils("maxHeightChart", maxValue);
        const chartOptions = this.chartOptions;
        chartOptions.scales.y.suggestedMax = maxValue;
        const barChartData = {
          labels: ["", "", "", "", "", "", "", "", "", "", ""],
          datasets: [
            {
              label: "Engaged",
              data: _drEngagedValue,
              backgroundColor: gradientFill,
              borderColor: "transparent",
              fill: true,
              pointHitRadius: 0,
              pointRadius: 0,
              pointHoverRadius: 0,
              tension: 0.4,
            },
            {
              label: "Old Engaged",
              data: _drEngagedOldValue,
              borderColor: "transparent",
              backgroundColor: "rgba(178, 178, 178, 0.4)",
              pointHitRadius: 0,
              pointRadius: 0,
              pointHoverRadius: 0,
              fill: true,
              tension: 0.4,
            },
          ],
        };
        if (this.myDirectReportsChart) {
          this.myDirectReportsChart.destroy();
        }
        this.myDirectReportsChart = new Chart(ctx, {
          type: "line",
          data: barChartData,
          options: chartOptions,
        });
      }
    },
    randerOverallTeamChartChart() {
      var chart = this.$refs.overallTeamChart;
      var ctx = chart.getContext("2d");
      var gradientFill = ctx.createLinearGradient(625, 0, 100, 0);
      gradientFill.addColorStop(1, "rgba(39, 188, 108, 0.6)");
      gradientFill.addColorStop(0.75, "rgba(98, 206, 148, 0.6)");
      gradientFill.addColorStop(0.5, "rgba(255, 186, 13, 0.6)");
      gradientFill.addColorStop(0.25, "rgba(255, 186, 13, 0.6)");
      gradientFill.addColorStop(0, "rgba(242, 47, 60, 0.6)");

      const _drEngagedValue = this.chartCofigNewData(
        this.overallTeam.engagedValue
      );
      const _drEngagedOldValue = this.chartCofigOldData(
        this.overallTeam.engagedValue
      );
      const allEngaged = [..._drEngagedValue, ..._drEngagedOldValue];
      let maxValue = 0;
      for (const x in allEngaged) {
        if (maxValue < allEngaged[x]) {
          maxValue = allEngaged[x];
        }
      }
      maxValue = this.$utils("maxHeightChart", maxValue);

      if (chart) {
        const chartOptions = this.chartOptions;
        chartOptions.scales.y.suggestedMax = maxValue;
        const barChartData = {
          labels: ["", "", "", "", "", "", "", "", "", "", ""],
          datasets: [
            {
              label: "Engaged",
              data: _drEngagedValue,
              backgroundColor: gradientFill,
              borderColor: "transparent",
              fill: true,
              pointHitRadius: 0,
              pointRadius: 0,
              pointHoverRadius: 0,
              tension: 0.4,
            },
            {
              label: "Old Engaged",
              data: _drEngagedOldValue,
              borderColor: "transparent",
              backgroundColor: "rgba(178, 178, 178, 0.4)",
              pointHitRadius: 0,
              pointRadius: 0,
              pointHoverRadius: 0,
              fill: true,
              tension: 0.4,
            },
          ],
        };
        this.myOverallTeamChart = new Chart(ctx, {
          type: "line",
          data: barChartData,
          options: chartOptions,
        });
      }
    },
    checkIcon(value) {
      return _.includes(value, " viewpoints that are positive & healthy");
    },
    setWaring(data) {
      this.warningModal = true;
      this.warningData.name = data.name;
      this.warningData.id = "this_is_your_id";
    },
    warning(value) {
      if (value) {
        this.$confirm(
          "This will permanently notify admins. Continue?",
          "Warning",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        )
          .then(() => {
            this.$message({
              type: "success",
              message: "Notify Admins for " + this.warning.name,
            });
            this.warningModal = false;
            console.log("warning NOTIFY ADMINS:", this.warning.name);
            // TODO: Code on here!
          })
          .catch(() => {
            this.warningModal = true;
          });
      } else {
        this.$confirm(
          "This will permanently cancel this warning. Continue?",
          "Warning",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        )
          .then(() => {
            this.warningModal = false;
          })
          .catch(() => {
            this.warningModal = true;
          });
      }
    },
    showVideo() {
      this.$emit("dialogValue", { value: true, text: "section-3" });
    },
    matchBackgroundColor(group) {
      let color = "#f7f4fc";
      switch (group) {
      case "highlyEngaged":
        color = "#D2F0E0";
        break;
      case "moderatelyEngaged":
        color = "#E6F5ED";
        break;
      case "somewhatEngaged":
        color = "#FDECC0";
        break;
      case "underEngaged":
        color = "#FAC9CC";
        break;
      case "inActive":
        color = "#EAEAEA";
        break;
      }
      return color;
    }
  },
};
</script>

<style lang="scss" scoped>
.warning-modal {
  position: absolute;
  z-index: 999;
  top: 4px;
  background-color: #606060;
  box-shadow: 0px 3px 24px #00000085;
  border-radius: 5px;
  padding: 24px 30px;
  width: 380px;
  .cancel,
  .notify {
    border-radius: 18px;
    font-size: 13px;
    font-weight: 700;
    color: #6d27bf;
    padding: 6px 12px;
    cursor: pointer;
  }
  .cancel {
    background-color: #ffffff;
  }
  .notify {
    background-color: #3cfcc8;
  }
}
.insights-container {
  .chart-header {
    height: 230px;
    > .line {
      position: absolute;
      bottom: 14px;
      width: 100%;
      height: 1px;
      background-color: rgba($color: #000000, $alpha: 0.1);
    }
    .chart-absolute {
      position: absolute;
      height: 230px;
      width: 716px;
    }
    > .previous {
      position: absolute;
      top: 20px;
      right: 10px;
      width: 110px;
      > .color {
        border-radius: 4px;
        width: 22px;
        height: 22px;
        background-color: rgba($color: #b2b2b2, $alpha: 0.4);
        margin-right: 6px;
      }
      > span {
        color: #000;
        opacity: 0.98;
        font-size: 11px;
        font-weight: 700;
        padding-top: 2px;
      }
    }
  }
  .tab-header {
    transition: 0.3s;
    cursor: pointer;
    font-weight: 700;
    margin: auto;
    color: rgba($color: #15253c, $alpha: 0.5);
    position: relative;
    &:before {
      content: "";
      position: absolute;
      height: 2px;
      bottom: -1px;
      transition: 0.3s;
      background-color: #6d27bf;
      width: 0%;
    }
  }
  .tab-header.left {
    &:before {
      left: 100%;
    }
  }
  .tab-header.right {
    &:before {
      right: 100%;
    }
  }
  .tab-header.active-tab {
    color: #6d27bf;
    &:before {
      width: 100%;
    }
  }
  .tab-header.left.active-tab {
    &:before {
      left: 0;
    }
  }
  .tab-header.right.active-tab {
    &:before {
      right: 0;
    }
  }
  .type-tabs {
    .card {
      border-radius: 4px;
      padding: 6px 14px 10px;
      margin: auto;
      .number {
        border-radius: 4px;
        width: 42px;
        height: 32px;
        padding: 4px;
        font-size: 20px;
        font-weight: 900;
        background-color: rgba($color: #27bc6c, $alpha: 0.5);
      }
      .number.superEngaged {
        background-color: rgba($color: #27bc6c, $alpha: 0.2);
      }
      .number.highlyEngaged {
        background-color: rgba($color: #27bc6c, $alpha: 0.2);
      }
      .number.moderatelyEngaged {
        background-color: rgba($color: #27bc6c, $alpha: 0.1);
      }
      .number.somewhatEngaged {
        background-color: rgba($color: #ffba0d, $alpha: 0.25);
      }
      .number.notEngaged {
        background-color: rgba($color: #f22f3c, $alpha: 0.25);
      }
      .number.inActive {
        background-color: rgba($color: #b2b2b2, $alpha: 0.25);
      }
      .text {
        color: #000;
        margin-left: 6px;
        opacity: 0.8;
        font-size: 14px;
        font-weight: 700;
      }
    }
    .card.focus {
      box-shadow: 0 3px 6px #00000029;
    }
  }
  .carousel {
    max-height: 250px;
    .arrow {
      transition: 0.2s;
      width: 32px;
      height: 32px;
      border-radius: 32px;
      box-shadow: 0 0 6px #00000029;
      cursor: pointer;
      &:hover {
        box-shadow: 0 0 3px #00000049;
      }
    }
    .arrow.left {
      margin-right: 18px;
    }
    .arrow.right {
      margin-left: 18px;
    }
    .arrow.hide {
      opacity: 0;
      cursor: none;
    }
    .engaged-contrainer {
      .engaged-card {
        min-height: 230px;
        width: 240px;
        background-color: #fff;
        border: 1px solid #00000033;
        border-radius: 11px;
        padding: 16px;
        color: #000;
      }
      .engaged-card.in-active {
        background-color: #f0f0f0;
        border: 1px solid #00000033;
        color: #000;
      }
    }
  }
  .highly-engaged-card {
    padding: 24px;
    border-radius: 6px;
    border: 1px solid #6d27bf33;
    background-color: #f7f4fc;
    box-shadow: 0 3px 6px #00000029;
    > .profile-card {
      padding: 16px 16px 28px;
      border-radius: 11px;
      background-color: #fff;
      border: 1px solid #00000033;
      box-shadow: 0 3px 6px #00000029;
      display: grid;
      grid-template-columns: 50% 50%;
      .right-card {
        display: grid;
        grid-template-columns: calc(50% - 4px) calc(50% - 4px);
        grid-gap: 8px;
        .challenges {
          color: #000;
          font-size: 13px;
          font-weight: 700;
          .status {
            width: 24px;
            height: 24px;
            border-radius: 24px;
            background-color: #bbbbbb;
            margin-right: 12px;
          }
          .status.green {
            background-color: #27bc6c;
          }
          .status.red {
            background-color: #f22f3c;
          }
          .status.yellow {
            background-color: #ffba0d;
          }
        }
      }
    }
  }
}
</style>